export default function deepUpdate(object, strPath, value) {
  const path = strPath.split('.');
  const key = path.shift();

  return {
    ...object,
    [key]: path.length > 0 ? deepUpdate(object[key], path.join('.'), value) : value,
  };
}
